import { useQuery } from '@tanstack/react-query';
import { auth } from '../config/firebase';

export interface AccessSubscription {
  status?: string;
  plan?: string;
  isActive?: boolean;
  period?: { start?: string; end?: string } | null;
}

export interface AccessResponse {
  success: boolean;
  user?: {
    currentOrgId?: string;
    hasAccess?: boolean;
    accessReason?: string;
  };
  orgContext?: { orgId: string; name: string } | null;
  orgSubscription?: AccessSubscription | null;
  access?: { isEntitled?: boolean; reason?: string };
}

export const useAccess = () => {
  return useQuery<AccessResponse>({
    queryKey: ['access'],
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    retry: false,
    queryFn: async () => {
      const token = await auth.currentUser?.getIdToken();
      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await fetch('https://api.socialness.ai/management/access', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch access (status: ${response.status})`);
      }

      return response.json();
    }
  });
};
